import { Store } from "pullstate";
var ACRStore = new Store({
  workspaceConfigs: {},
  fieldConfigs: {},
  crossFieldRules: {},
  registryTaggedFields: {},
  currentWorkspaceId: null,
  currentPatientId: null,
  pendingOAuthState: null,
  acrLoggedInState: {},
  submissionDetails: {},
  submissionFormData: {},
  submissionReadyStatus: {},
  submissionChangedFields: {},
  submissionOriginalFieldData: {},
  fieldErrors: {},
  fullFieldErrors: {},
  submitErrors: {},
  originalErrorFields: {},
  pendingPatientSwitch: null,
  pendingBackToSummary: null,
  minimizedSubmissions: {}
});
export default ACRStore;